import styled from "styled-components"

export const CopyrightContainer = styled.div`
background-color: black;
width:fit-content;
padding:10px;
margin:0 auto;
`

export const CopyrightText = styled.span`
color: white;
`